<template>
  <v-layout row wrap>
    <v-dialog
      v-model="syncloading"
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please stand by syncing WA Data
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-flex xs12>
      <v-card class="elevation-6">
        <v-btn @click="picMessage()" v-if="!embed" small absolute top right fab color="info" dark>
            <v-icon>sync</v-icon>
          </v-btn>
          
        <v-dialog v-model="dialog" persistent max-width="420">
          <v-card>
            <v-card-title class="headline">Send a message to a new contact</v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-select
                    label="Country"
                    :items="company_codes"
                    v-model="country"
                    outline
                    item-text="company_code"
                    item-value="company_code"
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Number"
                    v-model="nNumber"
                    outline
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    label="Message"
                    v-model="sMessage"
                    outline
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" outline @click="dialog = false">cancel</v-btn>
              <v-btn 
                color="success" 
                :disabled="!sMessage || !country || !nNumber"
                @click="sendMessageApi()"
              >Send</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-autocomplete
          :items="contactedNumbers"
          solo
          class="chatF"
          return-object
          clearable
          hide-selected
          :disabled="sending"
          item-text="text"
          v-model="selectedNumberChat"
          label="Select A Contact"
          v-if="!embed"
        >
          <template slot-scope="{ item, selected }" slot="selection">
            <v-chip
              :selected="selected"
              color="#efefef"
              class="primary--text"
            >
              <v-avatar
                size="avatarSize"
                class="elevation-2"
                color="secondary"
              >
              </v-avatar>
              <span class="font-weight-black">{{item.number}}</span>
            </v-chip>
          </template>
          <template slot-scope="{item}" slot="item">
            <v-list-tile-avatar
              class="headline font-weight-light white--text"
              :color="item.need?'primary':'white'"
            >
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title class="font-weight-black" >{{item.number}}</v-list-tile-title>
              <v-list-tile-sub-title>
                {{item.status }}  |  {{ (item.need? 'Need Reply' : '')}}
              </v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon>language</v-icon>
            </v-list-tile-action>
          </template>
        </v-autocomplete>
        <v-layout row wrap>
          <v-flex xs12 md2 pa-2 LEFTPANNEL>
            <v-layout row wrap>
              <v-flex xs12 v-if="selectedNumberChat">
                <v-btn color="primary" :disabled="!selectedNumberChat"
                v-clipboard:copy="selectedNumberChat.number"
                large block
                v-clipboard:success="clipboardSuccessHandler"
                v-clipboard:error="clipboardErrorHandler">copy number</v-btn>
              </v-flex>
              <v-flex xs12 v-if="!embed">
                Filter By Status
                <v-autocomplete
                  :items="waStatuses"
                  v-model="selectedWAStatusFilter"
                  label="Filter By Status"
                  return-object
                  clearable
                  hide-details
                  @change="filterWAByStatus()"
                  :loading="statusLoading"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 pt-3 >
                <v-divider class="pb-2"></v-divider>
                Select a Status
                <v-autocomplete
                  :items="waStatuses"
                  v-model="selectedWAStatus"
                  label="Select a Status"
                  return-object
                  clearable
                  hide-details
                  append-outer-icon="add"
                  @click:append-outer="addWAStatusdialog = true"
                  :loading="statusLoading"
                  :disabled="!selectedNumberChat"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-btn 
                  :disabled="!selectedWAStatus || !selectedNumberChat" 
                  @click="storeWAStatus()" 
                  outline 
                  color="primary" 
                  small 
                  block 
                  :loading="statusLoading"
                >save</v-btn>
              </v-flex>
              <v-flex xs12 v-if="!embed">
                <v-btn @click="dialog = true" small block color="info" dark>
                  <v-icon left>add</v-icon> new contact
                </v-btn>
              </v-flex>
              <v-flex xs12 v-if="!embed">
                <v-select
                  :items="['1', '2', '7', '14', '28', '60', '90']"
                  v-model="period"
                  label="Sync Period"
                ></v-select>
                <v-btn @click="picMessage()" small block color="info" dark>
                  <v-icon left>sync</v-icon> sync contacts
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 md10 style="background-color: #e9e5df;" RIGHTPANNEL>
            <div v-chat-scroll="{always: true, smooth: true}" :class="`${embed? 'embed-chat-container' : 'chat-container'}`">
              <v-layout row wrap>
                <v-flex  v-for="msg in chatMessages" :key="msg.time + msg.idgen" :class="` ${(msg.own?'text-xs-right':'')}`" xs12>
                  <v-layout row wrap>
                    <v-flex xs12>
                    </v-flex>
                    <v-flex xs12>
                      <v-icon clas="cStat" size="15px" v-if="msg.sent && !msg.delivered">done</v-icon>
                      <v-icon clas="cStat" size="15px" v-if="msg.delivered && !msg.viewed">done_all</v-icon>
                      <v-icon clas="cStat" size="15px" v-if="msg.viewed" color="primary">done_all</v-icon>
                      <div :class="`chatBubble ${(msg.own?'ownBub':'')}`" >
                          <v-tooltip top>
                            <div slot="activator" style="font-size:8px">{{ new Date(parseInt(msg.time + '000')) .toLocaleString('en-GB') }} | {{msg.user}}</div>
                            <span>{{ new Date(parseInt(msg.time + '000')) .toLocaleString('en-GB') }}  | {{msg.user}}</span>
                          </v-tooltip>
                          <div v-if="msg.official && msg.type != 'text'">
                            <img v-if="msg.media_mime && msg.media_mime.includes('image')" :src="msg.official_media" width="100%">
                            <video v-else width="100%"  controls>
                              <source :src="msg.official_media" >
                            </video>
                          </div>

                          <div v-if="msg.type == 'image'">
                            <img :src="msg.body"  width="100%"><div v-if="msg.caption">{{msg.caption}}</div>
                          </div>
                          <div v-if="msg.type == 'audio'">
                            <video width="100%"  controls>
                              <source :src="msg.body" >
                            </video>
                          </div>
                          <div v-if="msg.type == 'video'">
                            <video width="100%"  controls>
                              <source :src="msg.body" >
                            </video>
                          </div>

                          <div v-if="msg.type != 'image' && msg.type != 'audio'&& msg.type != 'video' && msg.body && !msg.body.includes('firebase') && !msg.body.includes('chat-api.com') && !msg.body.includes('wasabisys.com')">{{msg.body}}</div>
                          <div v-else-if="msg.body 
                          && (msg.body.includes('firebase') || msg.body.includes('chat-api.com') || msg.body.includes('wasabisys.com'))
                          && !msg.body.includes('oga')
                          && !msg.body.includes('mp4')">
                            <img :src="msg.body"  width="100%"><div>{{msg.caption}}</div>
                          </div>
                          <div v-else-if="msg.body 
                          && (msg.body.includes('firebase') || msg.body.includes('chat-api.com') || msg.body.includes('wasabisys.com'))
                          && msg.body.includes('oga')
                          && msg.body.includes('mp4')">
                            <video width="100%"  controls>
                              <source :src="msg.body" >
                            </video>
                          <div v-if="msg.caption">{{msg.caption}}</div></div>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex 
                  v-if="chatMessages.length != 0 
                  && chatMessages[chatMessages.length-1].fromme == 'False' 
                  && selectedNumberChat.need" 
                  xs12 class="justify-center text-xs-center">
                  
                  <v-btn @click="markAsRead()" outline color="primary" dark>mark as read</v-btn>
                  
                  
                </v-flex>
                <v-flex xs12 v-if="sender" class="text-xs-center" style="font-size:11px;font-weight:bold;">
                  LAST MARK AS READ: {{ selectedNumberChat.mark_as_read }}
                </v-flex>
                <v-flex xs12 v-if="sender" class="text-xs-center" style="font-size:11px;font-weight:bold;">
                  {{sender.cc}} | {{sender.number}}
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
        </v-layout>   
        <div>
          <input
            type="file"
            style="display: none"
            ref="file"
            accept="csv/*"
            @change="onFilePicked"
          >
          <div v-if="imgURL" class="imagePreview" >
            <div style="position:absolute;z-index:19000;">
              <v-btn @click="removeImage" color="error" icon>
                <v-icon>close</v-icon>
              </v-btn>
            </div>
            <div style="position:absolute;z-index:19000;right:0;">
              <v-btn @click="sendMessageApi()" color="success" icon>
                <v-icon>send</v-icon>
              </v-btn>
            </div>
            <img v-if="!imgURL.includes('mp4')" class="imageItself" :src="imgURL">
            <video v-else width="200"  controls>
              <source :src="imgURL" >
            </video>
          </div>
          <v-text-field 
            solo 
            :loading="loading"
            class="chatF"
            height="60"
            label="...." 
            :disabled="imgURL ? true : null"
            :readonly="imgURL ? true : null"
            v-model="sMessage"
            prepend-inner-icon="add_photo_alternate"
            @click:prepend-inner="addImage()"
            append-icon="send"
            @click:append="sendMessageApi()"
            @keyup.enter="sendMessageApi()"
          ></v-text-field>
        </div>
        <v-card-actions v-if="embed">
          <v-btn color="success" :disabled="nsentAmsg" flat block @click="qDone(qitem)">done</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
    <v-dialog fullscreen v-model="dialogs.qr" persistent max-width="600">
        <v-card>
          <v-card-title class="headline">Please Scan QR</v-card-title>
          <v-card-text class="text-xs-center">
            <v-layout row wrap>
              <v-flex xs12>
                <img :src="qrCode">
              </v-flex>
              <v-flex xs12>
                <v-btn outline color="primary" @click="checkWA()" dark>Scan Then Click here</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-progress-circular indeterminate v-if="loading" color="primary"></v-progress-circular>
            <v-spacer></v-spacer>
            <v-btn outline color="error" @click="dialogs.qr = null">{{ qrCode ? 'cancel' : 'close' }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    <v-dialog v-model="addWAStatusdialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">You want to add a new status?</v-card-title>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                label="Status"
                required
                v-model="newWAStatus"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click="addWAStatusdialog = false">Cancel</v-btn>
          <v-btn :disabled="!newWAStatus" color="green darken-1" flat @click="addWAStatus()">add</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import Papa from 'papaparse'
import axios from 'axios';
import { uuid } from '@/customFunction';
import virtualList from 'vue-virtual-scroll-list'
import { storageRef, firebase, db, auth, store } from '@/fb';
import { getRandomInt, randomString, getCDate, check } from '@/customFunction';
const api = 'https://us-central1-ashyaatcrm.cloudfunctions.net/main'
const headers = {
  'Accept': 'application/json'
}


export default {
  components: {
    'virtual-list': virtualList,
  },
  data() {
    return {
      instances:[],
      url:null,
      dialog:false,
      txtdialog:false,
      dialogs:{
        qr:false
      },
      name:null,
      file:null,
      loading:true,
      sNumber:null,
      sMessage:null,
      csv:null,
      sending:false,
      qrCode:null,
      qr:null,
      messagesH:[],
      messages:[],
      detailedViewsHeaders:[],
      detailedViews:[],
      contacts:[],
      contactedNumbers:[],
      selectedNumber:null,
      selectedNumberChat:null,
      chatMessages:[],
      myMSGS:[],
      clientMSGS:[],
      nNumber:null,
      fName:null,
      lName:null,
      nSMessage:null,
      myNumbers:[],
      syncloading:false,
      realLsner: null,
      lsnrTopN: null,
      lsnrLowN: null,
      waStatuses: [],
      selectedWAStatus: null,
      addWAStatusdialog: null,
      newWAStatus: null,
      statusLoading:false,
      contactedNumbersLoaded:[],
      selectedWAStatusFilter: null,
      file: null,
      uploadURL: null,
      fileName:null,
      imgURL: null,
      imgURLExt: null,
      countries:[
        {value:'JO', text:'Jordan'},
        {value:'AE', text:'UAE'},
        {value:'SA', text:'KSA'},
        {value:'IQ', text:'Iraq'},
        {value:'OM', text:'Oman'},
        {value:'BH', text:'Bahrain'},
        {value:'QA', text:'Qatar'},
        {value:'KW', text:'Kuwait'},
        {value:'PS', text:'Palestine'},
      ],
      country:null,
      period:'2',
      single:true,
      products: [],
      selectedProduct:null,
      productLoading:false,
      imgdialog:false,
      viddialog:false,
      senders:[],
      sender:null,
      nsentAmsg:true,
      company_codes:[],
    }
  },
  methods: {
    async loadCompanyCodes(){
      this.loading = true
      let a = await db.ref('settings/company_codes').once('value').then(x=>x.val())
      if(a){
        let b = Object.keys(a)
        this.company_codes = Object.values(a).map((x, i)=>{
          return {
            ...x,
            key:b[i]
          }
        })
        console.log(this.company_codes)
      }
      this.loading = false
    },
    async getInstances(){
      let a = await db.ref('settings/newwa/numbers').once('value').then(x => x.val())
      if(a) {
        let b = Object.keys(a)
        this.instances = Object.values(a).map((x, i)=>{
          return {
            ...x, 
            key:b[i]
          }
        })
      }
    },
    async showImage(instance_id, id){
      return new Promise(async (res, rej)=>{
        let inst = this.instances.filter(x=> x.key == instance_id)
        if(inst.length) {
          let selected = inst[0]
          let a = await axios({
            url: `${api}/getWAMedia/${selected.key}/${id}`,
            method: 'GET',
            responseType: 'blob', // important
          }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            res(link)
            // link.setAttribute('download', 'image.jpg');
            // document.body.appendChild(link);
            // link.click();
          });
          // let a = await axios.get(, {headers}).then(x=>x.data)
          // console.log(a)
          // res(a)  // 'data:image/jpg;base64,' + a
        }
      })
    },
    async fImage(instance_id, id) {
      let b = await this.showImage(instance_id, id)
      return b
    },
    async getOfficialImages(mss) {
      return new Promise(async (res, rej)=>{
        let msgs = mss.filter(x=>x.type !='text' && x.official);
        (async x=>{
          for (let i = 0; i < msgs.length; i++) {
            const msg = msgs[i];
            msg.official_media = `https://apis.maen.me/wam?instance=${3}&id=${msg.media_id}`
            console.log(msg.official_media)
          }
          res(true)
        })()
      })
    },
    async qDone(item, nocount) {
      this.qItemDone(item, nocount)
      this.$emit('removeItem', this.$props.itemO)
    },
    async qItemDone(item, nocount){
      console.log(item)
      await db.ref(`quitems/`).update({[item.q.key]:null})
      await db.ref(`quusers/${item.q.user}/q/`).update({[item.q.ukey]:null})
      if(!nocount){
        await db.ref(`quusers/${item.q.user}/amsgs/`).transaction(function (current_value) {
          return (current_value || 0) + 1;
        });
        let d = new Date().getDate()
        let m = new Date().getMonth() + 1
        await db.ref(`quusers/${item.q.user}/msgs/${d}-${m}/`).transaction(function (current_value) {
          return (current_value || 0) + 1;
        });
      }
      await db.ref(`q/q`).transaction(function (current_value) {
        return (current_value || 0) - 1;
      });
      await db.ref(`q/assigned`).transaction(function (current_value) {
        return (current_value || 0) - 1;
      });
    },
    async loadProducts(){
      this.productLoading = true
      let a = await db.ref(`productsCoreLite`).once('value').then(x=>x.val())
      if(a){
        this.products = Object.values(a).map(x=>{
          return {
            ...x,
            short_description:x.description_ar?x.description_ar.replace(/<\/?.+?>/ig, '').replace(/&nbsp;/g, ''):null,
          }
        })
      }
      this.productLoading = false
    },
    async markAsRead() {
      await store.collection(`waconversations`).doc(this.selectedNumberChat.key)
      .update({
        need:false,
        mark_as_read:this.$props.userName,
      })
    },
    sendImageVideo(media){
      this.imgURL = media
      this.sendMessageApi()
    },
    sendDesc(d) {
      this.sMessage = d
      console.log(this.sMessage)
      this.sendMessageApi()
    },
    sendUses(usArray) {
      this.sMessage = usArray.join('\n\r')
      console.log(this.sMessage)
      this.sendMessageApi()
    },
    async sendMessageApi(){
      if (!this.selectedNumberChat && !this.nNumber) {
        this.$emit('snackbarNotification', `Choose a contact please`, 'error')
        return
      }
      if(!this.sMessage && !this.imgURL) {
        this.$emit('snackbarNotification', `No message to send`, 'error')
        return
      }
      this.loading = 'error'
      this.sending = true
      this.nsentAmsg = false
      let template = {
        name:`starting`,
        namespace:`b9796543_bcb1_4152_bd49_66173da70fd8`,
        language:`ar`,
        components:[
          {
            type: "body",
            parameters: [
                {
                    type: "text",
                    text: this.sMessage
                }
            ]
          }
        ]
      }
      let post = {
        number: this.nNumber ? this.nNumber :  this.selectedNumberChat.number,
        country: this.country,
        message: this.sMessage,
        user: this.$props.userName,
        template
      }
      if(this.imgURL) {
        Object.assign(post,{
          media: {
            url: this.imgURL,
            caption: this.sMessage ? this.sMessage : '',
          }
        })
        delete post.message
      }
      
      // let send = await axios.post(`// WA API //`, post, {headers:headers}).then(x=>x.data)
      // console.log(send)
      // if(send.success) {
      //   this.sending = false
      //   this.sMessage = null
      //   this.file = null
      //   this.imgURL = null
      //   this.imgURLExt = null
      //   this.loading = false
      //   this.nNumber = null
      //   this.dialog = false
      // } else if(send.qr){
      //   this.dialogs.qr = true
      //   this.loading = false
      //   this.qrCode = send.qr
      //   this.$emit('snackbarNotification', `Please scan ${send.number} QR code`, 'error')
      // } else {
      //   this.$emit('snackbarNotification', `${send.number?send.number:''} ${send.message}`, 'error')
      // }
      
    },
    async storeWAStatus(){
      if(!this.selectedNumberChat.number && !this.selectedWAStatus) return
      this.statusLoading = true
      await store.collection(`waconversations`).doc(this.selectedNumberChat.key)
      .update({
        status:this.selectedWAStatus
      })
      await this.qDone(this.$props.qitem, true)
      this.statusLoading = false
    },
    addWAStatus(){
      db.ref(`wastatuses`).push({
        name:this.newWAStatus
      })
      .then(x=>{
        this.addWAStatusdialog = false
      })
    },
    getWAStatuses(){
      db.ref(`wastatuses`).once('value')
      .then(x=>{
        let ss = x.val()
        for (const key in ss) {
          if (ss.hasOwnProperty(key)) {
            const s = ss[key];
            this.waStatuses.push(s.name)
          }
        }
      })
    },
    addImage(){
      console.log('s')
      this.pickFile()
    },
    pickFile() {
      this.$refs.file.click()
    },
    loadFile(file, type, ext){
      var file = file
      var metadata = {
        contentType: type
      };
      var uploadTask = storageRef.child('images/ashyaat' + randomString(8, 'Aa#') + '.' + ext).put(file, metadata);
      uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
        (snapshot)=> {
          var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          this.upload = progress
                }, (error) =>{
          console.log(error);

        switch (error.code) {

          case 'storage/unauthorized':
            break;
          case 'storage/canceled':
            break;
          case 'storage/unknown':
            break;
        }
      },() => {
        uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) =>{
          console.log('File available at', downloadURL);
          this.uploadURL = downloadURL
          this.imgURL = downloadURL
          this.loading = false
        });
      });
    },
    onFilePicked (e) {
      this.loading = true
      const files = e.target.files
      if(files[0] !== undefined) {
        const fr = new FileReader ()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.file = files[0] // this is an image file that can be sent to server...
          console.log(this.file)
          this.imgURLExt = `.${this.file.name.split('.').pop()}`
          this.loadFile(this.file, this.file.type, this.file.name.split('.').pop())
        })
      } else {
        this.name = null
        this.fileName = null
        this.uploadURL = null
      }
    },
    removeImage(){
      this.imgURL = null
      this.imgURLExt = null
    },
    scrollToEnd() {
      try {
        var container = document.querySelector(".chat-container") ? document.querySelector(".chat-container") : document.querySelector(".embed-chat-container");
        setTimeout(x=>{
          container.scrollTop = container.scrollHeight;
        }, 1000)
        this.scroll()
      } catch (error) {}
    },
    scroll () {
      try {
        document.querySelector(".chat-container").onscroll = () => {
          console.log(document.querySelector(".chat-container").scrollHeight)
        };
      } catch (error) {}
    },
    async chat(){
      this.loading = true
      if(!this.selectedNumberChat || this.selectedNumberChat.key) {
        //return
      }
      this.selectedWAStatus = this.selectedNumberChat.status
      console.log(this.selectedNumberChat.sender_key)
      ///// FOR OFFICIAL IMAGES
      // let test_key = this.senders.filter(x=>x.key == this.selectedNumberChat.sender_key)[0].key
      // let inst = test_key  == 'fJ35ZVgiLV' ? 3 : test_key == 'ELxPkYMUf3' ? 5 : 4
      let mss = await store.collection(`waconversations`).doc(this.selectedNumberChat.key).collection('messages')
      .get().then(x => x.docs.map(y => {return {...y.data(), key:y.id}}))
      this.chatMessages = []
      this.chatMessages = mss.map(x=>{
        return  {
          ...x, 
          idgen:uuid(),
          // official_media:`https://apis.maen.me/wam?instance=${inst}&id=${x.media_id}`,
          own: x.fromme == "True" ? true : false
        }
      }).sort((a,b)=> a.time - b.time)
      this.scrollToEnd()
      console.log(mss)
      console.log(this.chatMessages)
      this.sender = this.senders.filter(x=>x.key == this.selectedNumberChat.sender_key)[0]
      console.log(this.sender)
      this.loading = false

      return true
      console.log(this.selectedNumberChat)
      if(!this.selectedNumberChat){
        if(this.lsnrLowN && this.realLsner) {
          db.ref(`whatsapp/${this.lsnrLowN}`).off('value', this.realLsner)
        }
        this.chatMessages = []
        this.loading = false
        return
      }
      let sContact = this.contacts.filter(c => c.number == this.selectedNumberChat.number)[0]
      if(this.lsnrLowN && this.realLsner) {
        db.ref(`whatsapp/${this.lsnrLowN}`).off('value', this.realLsner)
      }
      this.lsnrLowN = this.selectedNumberChat.number
      this.realLsner = store.collection(`waconversations`).doc(this.selectedNumberChat.key).collection('messages').onSnapshot( c=>{
        this.chatMessages = []
        let contact = c.data()
        this.selectedWAStatus = contact.status
        let messages = contact.messages
        for (const key in messages) {
          if (messages.hasOwnProperty(key)) {
            const message = messages[key];
            message.key = key
            message.idgen = uuid()
            this.chatMessages.push(message)
          }
        }
        let ownmsgs = this.chatMessages.filter(msg=> msg.fromme == "True")
        ownmsgs.forEach(x=>{
          x.own = true
        })
        this.scrollToEnd()
        this.loading = false
      })
      this.scrollToEnd()

    },
    filterWAByStatus(){
      if(!this.selectedWAStatusFilter) {
        this.contactedNumbers = this.contactedNumbersLoaded.sort((a, b)=> b.last_message - a.last_message); 
        this.loading = false
        return;
      }
      this.contactedNumbers = this.contactedNumbersLoaded.filter(x=> x.status == this.selectedWAStatusFilter).sort((a, b)=> b.last_message - a.last_message)
      this.loading = false
    },
    async picMessage(){
      this.syncloading = true
      // let a = await axios.get(`// WA API //?days=${this.period}`)
      // .then(resp=>resp.data)
      // console.log(a)
      // let b = a? Object.values(a).map(x=>{
      //   return {
      //     ...x,
      //     text:`${x.number} | ${x.name} | ${x.need? 'Need Replay New':''}`
      //   }
      // }): []
      // this.contactedNumbers = b
      // this.contactedNumbersLoaded = b
      // this.filterWAByStatus()
      this.syncloading = false
      this.loading = false
    },
    async getSingle(number){
      console.log(number)
      let a = await store.collection(`waconversations`).where('number', '==', parseInt(number.trim()))
      .get()
      .then(x=>x.docs.map(y=>{return {...y.data(), key:y.id}}));
      console.log(a)
      
      a=a.map(a=>{return {...a, text :`${a.number} | ${a.name} | ${a.need? 'Need Replay New':''}`}})
      this.contactedNumbers = [...a]
      this.contactedNumbersLoaded = [...a]
      this.filterWAByStatus()
      this.selectedNumberChat = a[a.length-1]
      this.syncloading = false
      this.loading = false
      
    },
    clipboardSuccessHandler ({ value, event }){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    async getSenders(){
      return new Promise(async (res, rej)=>{
        let a = await db.ref('settings/newwa/numbers').once('value').then(x => x.val())
        this.senders = Object.values(a)
        res(true)
      })
    }
  },
  props: {
    qitem: {
      default: false
    },
    userName: {
      required: true,
      default: 'user'
    },
    userRole: {
      required: true,
      default: 'user'
    },
    beta: {
      required: true,
      default: false
    },
    superAdmin: {
      required: true,
      default: false
    },
    embed: {
      default: false
    },
    number: {
      default: false
    },
    itemO: {
      default: false
    },
  },
  watch:{
    selectedNumberChat(){
      this.imgURL = null
      this.imgURLExt = null
      this.chat()
    },
    number(){
      if(this.$props.number) {
        this.getSingle(this.$props.number)
      }
    },
   
  },
  computed:{
   
  },
  async created() {
    await this.getSenders()
    this.getInstances()
    this.loadCompanyCodes()
    this.getWAStatuses()
    // this.loadProducts()
    let p = this.$route.params
    if(p && p.number) {
      console.log('------------------------------------');
      console.log(p);
      console.log('------------------------------------');
      this.getSingle(p.number)
    } else {
      if(!this.$props.number){
        this.picMessage()
      }
    }
    if(this.$props.number){
      this.getSingle(this.$props.number)
    }
    
  },
  mounted(){
    
  }
  
}
</script>

<style>
.chat-container {
  box-sizing: border-box;
  height: calc(100vh - 13.0rem);
  overflow-y: auto;
  padding: 10px;
  box-shadow: inset 0px 0px 3px rgba(0, 0, 0, 0.65);
}
.embed-chat-container {
  box-sizing: border-box;
  height: 300px;
  overflow-y: auto;
  padding: 10px;
  box-shadow: inset 0px 0px 3px rgba(0, 0, 0, 0.65);
}
.chat-container::after {
  content: "";
  background-image: url("/bgchat.png");
  background-repeat: repeat;
  opacity: 0.09;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  z-index: -1;   
}
.chatF .v-input__slot {
  margin-bottom:0 !important;
}
.chatF .v-text-field__details {
  display: none
}

.chatF .v-progress-linear {
  height: 5px !important;
}

.chatBubble {
  padding: 8px;
  background-color: #90ee90;
  border-radius: 10px;
  display: inline-block;
  box-shadow: 0 1px 3px 0 rgba(0,0,0,.2), 0 1px 1px 0 rgba(0,0,0,.14), 0 2px 1px -1px rgba(0,0,0,.12);
  max-width: 50%;
  word-wrap: break-word;
  margin-bottom: 4px;
  z-index: 2;   

}

.ownBub {
  background-color: #FFEB3B;
}
.ownMsg {
  text-align: right;
}

.cStat {
  margin-right: 6px !important;
}
.imagePreview {
  border-radius: 3px;
  bottom: 53px;
  width: 200px;
  position: absolute;
  z-index: 101010;
  right: 20px;
  box-shadow: 0 0 4px black;
}
.imageItself {
  width: 200px;
  border-radius: 3px;

}
</style>
